/* eslint-disable react/prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import HTMLReactParser from 'html-react-parser';
// helpers
import { getNameFromArray } from '../../../helpers';
// mui
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const months = [
  { 'id': 1, 'name': 'Січень' },
  { 'id': 2, 'name': 'Лютий' },
  { 'id': 3, 'name': 'Березень' },
  { 'id': 4, 'name': 'Квітень' },
  { 'id': 5, 'name': 'Травень' },
  { 'id': 6, 'name': 'Червень' },
  { 'id': 7, 'name': 'Липень' },
  { 'id': 8, 'name': 'Серпень' },
  { 'id': 9, 'name': 'Вересень' },
  { 'id': 10, 'name': 'Жовтень' },
  { 'id': 11, 'name': 'Листопад' },
  { 'id': 12, 'name': 'Грудень' },
];

const ExperienceInfo = ({ cvDetails }) => {
  const { t } = useTranslation('global');

  const { experiences = [] } = cvDetails;

  return (
    <div className='experienceInfoSection'>
      <h4>
        {t('cvDescription.experience')}
      </h4>
      <div className='experienceInfoBox'>
        {
          experiences?.map(i => (
            <div key={i.id}>
              <h5>
                {i.position.label}
              </h5>
              <h6>
                {i.organization.label}
              </h6>
              <div className='industryBox'>
                {
                  i.industry?.map(industry => (
                    <p key={industry.id}>
                      <FiberManualRecordIcon sx={{ mr: '8px', width: '10px', height: '10px', color: '#294A9C' }} />
                      {industry.label}
                    </p>
                  ))
                }
              </div>
              <div className='workDurationBox'>
                <p className='workDuration'>
                  <i className='fa-solid fa-calendar-days' />
                  {getNameFromArray(i.from_month_exp, months)}{' '}{i.from_year_exp}
                  {i.to_year_exp || i.still_working ? ' - ' : ''}
                  {
                    i.still_working
                      ? t('cvDescription.stillWorking')
                      : i.to_year_exp
                        ? `${getNameFromArray(i.to_month_exp, months)} ${i.to_year_exp}`
                        : ''
                  }
                </p>
                {
                  i.exp_country && (
                    <p className='workDuration'>
                      <i className='fa-sharp fa-solid fa-location-dot' />
                      {i.exp_city && `${i.exp_city.label}, `}
                      {i.exp_country}
                    </p>
                  )
                }
              </div>
              <p className='achievements'>
                {t('cvDescription.achievements')}
              </p>
              <div className='standartListStyle'>
                {HTMLReactParser(i.achievements.replace(/ref="[^"]*"/g, ''))}
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default ExperienceInfo;
